import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9 12.005h3.75m-3.75 3h3.75m-3.75 3h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.113c0-1.135-.845-2.098-1.976-2.192a48 48 0 0 0-1.123-.08m-5.801 0q-.099.316-.1.664c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.3 2.3 0 0 0-.1-.664m-5.8 0a2.25 2.25 0 0 1 2.15-1.586H15a2.25 2.25 0 0 1 2.15 1.586m-5.8 0q-.563.033-1.124.08C9.095 4.015 8.25 4.978 8.25 6.113v2.142m0 0H4.875c-.621 0-1.125.503-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.38c0-.622-.504-1.125-1.125-1.125zm-1.5 3.75h.008v.007H6.75zm0 3h.008v.007H6.75zm0 3h.008v.007H6.75z"
    }, null, -1)
  ])))
}
export default { render: render }